const columns = {
  creatives: [
    {
      columnValue: (item) => item.creativeCode,
      fieldType: 'text',
      key: 'creativeCode',
      sortable: true,
      width: 150,
    },
  ],
  lineitems: [
    {
      align: 'start',
      class: 'lineitem-id',
      columnName: 'ID',
      columnValue: (item) => item.id,
      fieldType: 'text',
      formatAs: null,
      initialSorted: false,
      key: 'id',
      minWidth: 90,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'lineitem-name',
      columnName: 'Name',
      columnValue: (item) => item.name,
      fieldType: 'text',
      formatAs: null,
      initialSorted: true,
      key: 'name',
      minWidth: 90,
      required: false,
      sortable: true,
      width: 150,
    },
  ],
  networks: [
    {
      columnValue: (item) => item.networkCode,
      fieldType: 'text',
      key: 'networkCode',
      sortable: true,
      width: 150,
    },
  ],
  orders: [
    {
      align: 'start',
      class: 'order-id',
      columnName: 'ID',
      columnValue: (item) => item.id,
      fieldType: 'text',
      formatAs: null,
      initialSorted: false,
      key: 'id',
      minWidth: 90,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'order-name',
      columnName: 'Name',
      columnValue: (item) => item.name,
      fieldType: 'text',
      formatAs: null,
      initialSorted: true,
      key: 'name',
      minWidth: 90,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'order-start-date',
      columnName: 'Start Date',
      columnValue: (item) => item.startDateTime,
      fieldType: 'date',
      formatAs: ['dateObject', 'MM/DD/YYYY'],
      initialSorted: false,
      key: 'startDateTime',
      minWidth: 90,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'order-end-date',
      columnName: 'End Date',
      columnValue: (item) => item.endDateTime,
      fieldType: 'date',
      formatAs: ['dateObject', 'MM/DD/YYYY'],
      initialSorted: false,
      key: 'endDateTime',
      minWidth: 90,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'order-unlimited-end-date-time',
      columnName: 'Unlimited End DateTime',
      columnValue: (item) => item.unlimitedEndDateTime,
      fieldType: 'date',
      formatAs: null,
      initialSorted: true,
      key: 'unlimitedEndDateTime',
      minWidth: 90,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'order-last-modified-date-time',
      columnName: 'Last Modified DateTime',
      columnValue: (item) => item.lastModifiedDateTime,
      fieldType: 'date',
      formatAs: ['dateObject', 'MM/DD/YYYY'],
      initialSorted: true,
      key: 'lastModifiedDateTime',
      minWidth: 90,
      required: false,
      sortable: true,
      visible: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'order-is-archived',
      columnName: 'Archived',
      columnValue: (item) => item.isArchived,
      fieldType: 'boolean',
      formatAs: null,
      initialSorted: true,
      key: 'isArchived',
      minWidth: 90,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'order-status',
      columnName: 'Status',
      columnValue: (item) => item.status,
      fieldType: 'text',
      formatAs: null,
      initialSorted: true,
      key: 'status',
      minWidth: 90,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'order-is-programmatic',
      columnName: 'Programmatic',
      columnValue: (item) => item.isProgrammatic,
      fieldType: 'boolean',
      formatAs: null,
      initialSorted: true,
      key: 'isProgrammatic',
      minWidth: 90,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'order-applied-labels',
      columnName: 'Applied Labels',
      columnValue: (item) => item.appliedLabels,
      fieldType: 'text',
      formatAs: ['join', ', '],
      initialSorted: true,
      key: 'appliedLabels',
      minWidth: 90,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'order-effective-applied-labels',
      columnName: 'Effective Applied Labels',
      columnValue: (item) => item.effectiveAppliedLabels,
      fieldType: 'text',
      formatAs: ['join', ', '],
      initialSorted: true,
      key: 'effectiveAppliedLabels',
      minWidth: 90,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'order-custom-fields',
      columnName: 'Custom Fields',
      columnValue: (item) => item.customFieldValues,
      fieldType: 'text',
      formatAs: ['join', ', '],
      initialSorted: true,
      key: 'customFieldValues',
      minWidth: 90,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'order-notes',
      columnName: 'Notes',
      columnValue: (item) => item.notes,
      fieldType: 'text',
      formatAs: null,
      initialSorted: true,
      key: 'notes',
      minWidth: 90,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'order-total-budget',
      columnName: 'Budget',
      columnValue: (item) => item.totalBudget,
      fieldType: 'number',
      formatAs: 'microCurrency',
      initialSorted: true,
      key: 'totalBudget',
      minWidth: 90,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'order-clicks',
      columnName: 'Clicks',
      columnValue: (item) => item.totalClicksDelivered,
      fieldType: 'number',
      formatAs: null,
      initialSorted: true,
      key: 'unlimitedEndDateTime',
      minWidth: 90,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'order-impressions',
      columnName: 'Impressions',
      columnValue: (item) => item.totalImpressionsDelivered,
      fieldType: 'number',
      formatAs: null,
      initialSorted: true,
      key: 'totalImpressionsDelivered',
      minWidth: 90,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'order-viewable-impressions',
      columnName: 'Viewable Impressions',
      columnValue: (item) => item.totalViewableImpressionsDelivered,
      fieldType: 'number',
      formatAs: null,
      initialSorted: true,
      key: 'totalViewableImpressionsDelivered',
      minWidth: 90,
      required: false,
      sortable: true,
      width: 150,
    },
  ],
}

export default columns
